import Button from "../components/Common/Button";
import { useState } from "react";
import GradientLogo from '../../src/assets/images/nexusLogo.png';
import GradientLogoSmall from '../../src/assets/images/gradiant.png';
import CreatePodModal from "../components/PodModals/CreatePodModal";
import ToastMessage from "../components/Common/ToastMessage";
import { useNavigate } from "react-router-dom";
import GradientLogoInverse from '../../src/assets/images/GradientNEXUS_inverse.svg';
import GradientLogoSmallInverse from '../../src/assets/images/Gradient_G_inverse.svg';
import { useIsWriteRestrictedUser } from "../hooks/useIsWriteRestrictedUser";

export default function LandingPage() {
  const [showPodModal, setShowPodModal] = useState(false);
  const isAccessRestricted = useIsWriteRestrictedUser();

  const navigate = useNavigate();

  const [toast, setToast] = useState({
    show: false,
    message: '',
    type: 'success',
  });
  const showToast = (message, type = 'success') => {
    setToast({ show: true, message, type });
  };

  const handleNavigateToUnits = () => {
    navigate('/manageunits');
  }

  const handleNavigateToProperties = ()=>{
    navigate('/manageproperties');
  }
  return (
    <>
      <div className="flex flex-wrap lg:flex-nowrap h-full grow dark:bg-darkThemeBg">
        <div className="grow bg-white dark:bg-darkThemeBg p-8 lg:px-28 lg:py-10 basis-8/12 flex flex-col justify-center">
          <div className="imageHolder w-auto lg:w-72">
            <img src={GradientLogo} className="size-auto hidden lg:flex dark:hidden" alt="gradiant logo" />
            <img src={GradientLogoSmall} className="w-36 flex lg:hidden dark:hidden" alt="gradiant logo" />

            <img src={GradientLogoInverse} className="size-auto hidden dark:lg:flex" alt="gradiant logo" />
            <img src={GradientLogoSmallInverse} className="w-36 hidden dark:flex dark:lg:hidden" alt="gradiant logo" />
          </div>
          <div className="mt-6">
            <h3 className="flex flex-col gap-4">
              <span className="block text-dark-grey dark:text-white text-2xl leading-5 font-normal tracking-[0.036px]">Welcome to</span>
              <span className="text-[#1E555C] dark:text-white font-bold text-3xl leading-5 tracking-[0.054px] block" >Gradient Nexus</span>
            </h3>
          </div>
          <div className="mt-8 flex flex-col gap-6">
            <p className="text-dark-grey dark:text-white text-lg leading-8 lg:text-xl lg:leading-9 font-normal tracking-[0.03px] w-full lg:w-3/4">Your centralized platform to monitor, control, and optimize every Gradient across your portfolio.</p>
            <p className="text-dark-grey dark:text-white text-lg leading-8 lg:text-xl lg:leading-9 font-normal tracking-[0.03px] w-full lg:w-3/4">Unlock energy savings, reduce maintenance costs, and deliver superior comfort all from a single, intelligent dashboard.</p>
            <p className="text-theme font-semibold text-xl leading-7 lg:text-2xl lg:leading-9 tracking-[0.036px]">Let’s create your perfect climate!</p>
          </div>
        </div>
        <div className="basis-[480px] bg-light-ivory dark:darkThemeFade flex justify-center p-8 flex-1 border-0 lg:border-l-2 border-l-[#1e2a2c0d] dark:border-l-[#4E7AAC] dark:bg-[]">
          <div className="flex flex-col justify-center  gap-10">
            <div className="flex items-start gap-8" data-testid="landingpage-zone-section">
              <div className="iconHolder">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                  <path d="M31.1554 6.76393L35.1554 8.86304C39.4587 11.1213 41.6104 12.2505 42.8052 14.2795C44 16.3085 44 18.8333 44 23.883V24.117C44 29.1667 44 31.6915 42.8052 33.7205C41.6104 35.7495 39.4587 36.8787 35.1554 39.137L31.1554 41.2361C27.6442 43.0787 25.8885 44 24 44C22.1115 44 20.3558 43.0787 16.8446 41.2361L12.8446 39.137C8.54125 36.8787 6.38959 35.7495 5.19479 33.7205C4 31.6915 4 29.1667 4 24.117V23.883C4 18.8333 4 16.3085 5.19479 14.2795C6.38959 12.2505 8.54125 11.1213 12.8446 8.86304L16.8446 6.76393C20.3558 4.92131 22.1115 4 24 4C25.8885 4 27.6442 4.92131 31.1554 6.76393Z" stroke="#1E555C" strokeWidth="3" strokeLinecap="round" className="dark:stroke-white"/>
                  <path d="M42 15L24 24M24 24L6 15M24 24V43" stroke="#1E555C" strokeWidth="3" strokeLinecap="round" className="dark:stroke-white"/>
                </svg>
              </div>
              <div className="flex flex-col gap-6">
                <div className="infoHolder">
                  <div className="flex flex-col gap-2">
                    <h3 className="catagoryTitle text-dark-grey dark:text-white text-xl leading-6 lg:text-2xl lg:leading-8 font-semibold tracking-[0.036px]" data-testid="landingpage-zone-title">Zone</h3>
                    <p className="w-full sm:w-3/4 lg:w-[95%] text-dark-grey dark:text-white text-base leading-6 font-normal tracking-[0.024px]">Nexus Zone helps you organize Gradient units into logical groups - like by building, floor, or use case - so you can apply settings, view and control performance at scale.</p>
                  </div>
                </div>
                <div className="buttonHolder">
                  <Button
                    className={`bg-theme px-5 py-3 text-white text-base font-semibold leading-5 tracking-[-0.32px] rounded-md min-w-32 ${
                      isAccessRestricted ? "opacity-40 cursor-not-allowed" : "cursor-pointer"
                    }`}
                    onClick={() => setShowPodModal(true)}
                    disabled={isAccessRestricted}
                    data-testid="landingpage-create-zone-button"
                  >
                    Create Zone
                  </Button>
                </div>
              </div>
            </div>
            <div className="flex items-start gap-8" data-testid="landingpage-unit-section">
              <div className="iconHolder">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                  <path d="M27 31.375C27 27.6038 27 25.7181 28.1716 24.5466C29.3431 23.375 31.2288 23.375 35 23.375C38.7712 23.375 40.6569 23.375 41.8284 24.5466C43 25.7181 43 27.6038 43 31.375V35.375C43 39.1462 43 41.0319 41.8284 42.2034C40.6569 43.375 38.7712 43.375 35 43.375C31.2288 43.375 29.3431 43.375 28.1716 42.2034C27 41.0319 27 39.1462 27 35.375V31.375Z" stroke="#1E555C" strokeWidth="3" className="dark:stroke-white"/>
                  <path d="M4 17.375C4 21.1462 4 23.0319 5.17157 24.2034C6.34315 25.375 8.22876 25.375 12 25.375C15.7712 25.375 17.6569 25.375 18.8284 24.2034C20 23.0319 20 21.1462 20 17.375V13.375C20 9.60376 20 7.71815 18.8284 6.54657C17.6569 5.375 15.7712 5.375 12 5.375C8.22876 5.375 6.34315 5.375 5.17157 6.54657C4 7.71815 4 9.60376 4 13.375V17.375Z" stroke="#1E555C" strokeWidth="3" className="dark:stroke-white"/>
                  <path d="M27 11.375C27 9.51123 27 8.57935 27.3045 7.84427C27.7105 6.86415 28.4892 6.08546 29.4693 5.67948C30.2044 5.375 31.1362 5.375 33 5.375H37C38.8638 5.375 39.7956 5.375 40.5307 5.67948C41.5108 6.08546 42.2895 6.86415 42.6955 7.84427C43 8.57935 43 9.51123 43 11.375C43 13.2388 43 14.1706 42.6955 14.9057C42.2895 15.8858 41.5108 16.6645 40.5307 17.0705C39.7956 17.375 38.8638 17.375 37 17.375H33C31.1362 17.375 30.2044 17.375 29.4693 17.0705C28.4892 16.6645 27.7105 15.8858 27.3045 14.9057C27 14.1706 27 13.2388 27 11.375Z" stroke="#1E555C" strokeWidth="3" className="dark:stroke-white"/>
                  <path d="M4 37.375C4 39.2388 4 40.1706 4.30448 40.9057C4.71046 41.8858 5.48915 42.6645 6.46927 43.0705C7.20435 43.375 8.13623 43.375 10 43.375H14C15.8638 43.375 16.7956 43.375 17.5307 43.0705C18.5108 42.6645 19.2895 41.8858 19.6955 40.9057C20 40.1706 20 39.2388 20 37.375C20 35.5112 20 34.5794 19.6955 33.8443C19.2895 32.8642 18.5108 32.0855 17.5307 31.6795C16.7956 31.375 15.8638 31.375 14 31.375H10C8.13623 31.375 7.20435 31.375 6.46927 31.6795C5.48915 32.0855 4.71046 32.8642 4.30448 33.8443C4 34.5794 4 35.5112 4 37.375Z" stroke="#1E555C" strokeWidth="3" className="dark:stroke-white"/>
                </svg>
              </div>
              <div className="flex flex-col gap-6">
                <div className="infoHolder">
                  <div className="flex flex-col gap-2">
                    <h3 className="catagoryTitle text-dark-grey dark:text-white text-xl leading-6 lg:text-2xl lg:leading-8 font-semibold tracking-[0.036px]" data-testid="landingpage-unit-title">Unit</h3>
                    <p className="w-full sm:w-3/4 lg:w-[95%] text-dark-grey dark:text-white text-base leading-6 font-normal tracking-[0.024px]">A Unit refers to an individual Gradient device installed in your property.</p>
                  </div>
                </div>
                <div className="buttonHolder">
                  <Button
                    className={`bg-theme px-5 py-3 text-white text-base font-semibold leading-5 tracking-[-0.32px] rounded-md min-w-32 ${
                      isAccessRestricted ? "opacity-40 cursor-not-allowed" : "cursor-pointer"
                    }`}
                    onClick={handleNavigateToUnits}
                    disabled={isAccessRestricted}
                    data-testid="landingpage-units-get-started-button"
                  >Get Started
                  </Button>
                </div>
              </div>
            </div>
            <div className="flex items-start gap-8" data-testid="landingpage-property-section">
              <div className="iconHolder">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                  <path d="M10 16.0293C10 8.8334 16.268 3 24 3C31.732 3 38 8.8334 38 16.0293C38 23.1688 33.5317 31.4999 26.5601 34.4791C24.935 35.1736 23.065 35.1736 21.4399 34.4791C14.4683 31.4999 10 23.1688 10 16.0293Z" stroke="#1E555C" strokeWidth="3" className="dark:stroke-white"/>
                  <path d="M28 18C28 20.2091 26.2091 22 24 22C21.7909 22 20 20.2091 20 18C20 15.7909 21.7909 14 24 14C26.2091 14 28 15.7909 28 18Z" stroke="#1E555C" strokeWidth="3" className="dark:stroke-white"/>
                  <path d="M41.9211 32.25C43.2518 33.455 44 34.8132 44 36.25C44 41.2206 35.0457 45.25 24 45.25C12.9543 45.25 4 41.2206 4 36.25C4 34.8132 4.74824 33.455 6.07893 32.25" stroke="#1E555C" strokeWidth="3" strokeLinecap="round" className="dark:stroke-white"/>
                </svg>
              </div>
              <div className="flex flex-col gap-6">
                <div className="infoHolder">
                  <div className="flex flex-col gap-2">
                    <h3 className="catagoryTitle text-dark-grey dark:text-white text-xl leading-6 lg:text-2xl lg:leading-8 font-semibold tracking-[0.036px]" data-testid="landingpage-property-title">Property</h3>
                    <p className="w-full sm:w-3/4 lg:w-[95%] text-dark-grey dark:text-white text-base leading-6 font-normal tracking-[0.024px]">A Property is a site or complex where Gradient units are deployed — such as an apartment community or building portfolio. You can manage one or many properties within your Nexus dashboard.</p>
                  </div>
                </div>
                <div className="buttonHolder">
                  <Button
                    className={`bg-theme px-5 py-3 text-white text-base font-semibold leading-5 tracking-[-0.32px] rounded-md min-w-32 ${
                      isAccessRestricted ? "opacity-40 cursor-not-allowed" : "cursor-pointer"
                    }`}
                    onClick={handleNavigateToProperties}
                    disabled={isAccessRestricted}
                    data-testid="landingpage-properties-get-started-button"
                  >
                    Get Started
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showPodModal && (
        <CreatePodModal setShowPodModal={setShowPodModal} onCreateSuccess={() => {
          showToast("Created Successfully", "success");
        }} />
      )}

      <ToastMessage
        message={toast.message}
        type={toast.type}
        show={toast.show}
        onClose={() => setToast(prev => ({ ...prev, show: false }))}
      />
    </>
  );
}
